import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { useState } from 'react';

export const useEarningsThemeDrawer = () => {
  const [selectedThemeId, setSelectedThemeId] = useState<string>();
  const { trackThemeOverviewDrawerOpen } = usePosthogEvents();

  const handleOpenThemeDrawer = (themeId: string) => {
    trackThemeOverviewDrawerOpen(POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW, [
      themeId,
    ]);
    setSelectedThemeId(themeId);
  };

  const handleCloseThemeDrawer = () => setSelectedThemeId(undefined);

  return {
    handleOpenThemeDrawer,
    themeDrawerProps: {
      isOpen: !!selectedThemeId,
      onClose: handleCloseThemeDrawer,
      themeId: selectedThemeId,
    },
  };
};
